import { useLocation, useNavigate, useParams } from 'react-router-dom'
import './QuizResult.css'

interface Correction {
    questionId: string
    statement: string
    alternativeChosen: string | null
    correctAlternative: string
    correct: boolean
    explanation: string | null
}

interface ResultState {
    grade: number
    minimumGrade: number
    passed: boolean
    timeTakenSec: number
    totalQuestions: number
    corrections: Correction[]
}

export function QuizResult() {
    const { state } = useLocation() as { state: ResultState }
    const navigate = useNavigate()

    if (!state) {
        navigate('/catalogo')
        return null
    }

    const { grade, minimumGrade, passed, timeTakenSec, totalQuestions, corrections } = state
    const correctCount = corrections.filter(c => c.correct).length
    const mins = Math.floor(timeTakenSec / 60)
    const secs = timeTakenSec % 60

    return (
        <div className="container fade-in">
            <div className="result-wrap">
                <div className="result-medal">
                    <div className="result-medal-inner">{passed ? '✦' : '✗'}</div>
                </div>

                <div className="result-kicker">{passed ? 'Parabéns' : 'Quase lá'}</div>
                <h1 className="result-title serif">
                    {passed ? 'Você foi aprovado!' : 'Tente novamente'}
                </h1>
                <p className="result-sub">
                    {passed
                        ? 'Você demonstrou domínio do conteúdo. Continue assim!'
                        : `Você precisa de ${minimumGrade} para passar. Revise o conteúdo e tente de novo.`}
                </p>

                <div className="result-score">
                    <span className="big">{grade.toFixed(1)}</span>
                    <span className="small">/ 10</span>
                </div>

                <div className="result-info-grid">
                    <div className="result-info-cell">
                        <div className="label">Acertos</div>
                        <div className="val">{correctCount} de {totalQuestions} questões</div>
                    </div>
                    <div className="result-info-cell">
                        <div className="label">Tempo</div>
                        <div className="val">{mins}m {secs}s</div>
                    </div>
                    <div className="result-info-cell">
                        <div className="label">Nota mínima</div>
                        <div className="val">{minimumGrade}</div>
                    </div>
                    <div className="result-info-cell">
                        <div className="label">Situação</div>
                        <div className="val" style={{ color: passed ? 'var(--teal)' : 'var(--red)' }}>
                            {passed ? 'Aprovado' : 'Reprovado'}
                        </div>
                    </div>
                </div>

                <div className="result-actions">
                    <button className="btn btn-ghost" onClick={() => navigate('/catalogo')}>
                        ← Voltar ao catálogo
                    </button>
                </div>

                {corrections.length > 0 && (
                    <div className="result-corrections">
                        <h3 className="serif" style={{ marginBottom: 16 }}>Gabarito</h3>
                        {corrections.map((c, i) => (
                            <div key={c.questionId} className={`correction-item ${c.correct ? 'correct' : 'wrong'}`}>
                                <div className="correction-header">
                                    <span className="correction-num">Q{i + 1}</span>
                                    <span className={`correction-badge ${c.correct ? 'ok' : 'bad'}`}>
                                        {c.correct ? '✓ Correto' : '✗ Errado'}
                                    </span>
                                </div>
                                <div className="correction-statement">{c.statement}</div>
                                {c.explanation && (
                                    <div className="correction-explanation">{c.explanation}</div>
                                )}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    )
}